// import { Avatar, Box, Checkbox, makeStyles, TableBody, TableCell } from '@material-ui/core'
// import React, { useContext, useEffect, useState } from 'react'
// import CustomTable from '../components/Table/CustomTable'
// import CustomTableHeading from '../components/Table/CustomTableHeading'
// import CustomTableRow from '../components/Table/CustomTableRow'
// import { diffDateInHrs, formatDate, formatTime, handleSelectAllClick, handleSelectedItem, isSelected, ROUTES } from '../shared/constants'
// import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined'
// import CustomImage from '../components/CustomImage'
// import CustomLabel from '../components/CustomLabel'
// import Status from '../components/Status'
// import CustomPagination from '../components/CustomPagination'
// import Layout from '../components/Layout'
// import CustomHeading from '../components/CustomHeading'
// import { itemsPerPage } from '../shared/data'
// import Icon from '../assets/images/icons/Vector.svg'
// import ConfirmDialog from '../components/Dialog/ConfirmDialog'
// import Loader from '../components/Loader'
// import User from '../components/User'
// import Time from '../assets/images/icons/time.svg'

// import { ConfigurationContext } from '../context api/Configuration/ConfigurationContext'
// import { useAttendance } from '../hooks/Features/useAttendance'
// import { useParams } from 'react-router'
// import { NoDataFound } from '../components/NoDataFound'
// import ImageDialog from '../components/Dialog/ImageDialog'

// const useStyles = makeStyles({
//   icon: {
//     width: '22px',
//     height: '22px',
//     cursor: 'pointer',
//     marginLeft: '22px',
//     // marginTop: '4px',
//   },
//   icons: {
//     marginLeft: '20px',
//     cursor: 'pointer',
//   },
//   underline: {
//     borderBottom: '2px solid grey',
//   },
//   formControl: {
//     minWidth: 120,
//     minHeight: '40px',
//   },
//   cursor: {
//     cursor: 'pointer',
//   },
//   locationIcon: {
//     color: '#32499F',
//   },
//   errorheading: {
//     margin: '100px 0px 200px 450px',
//   },
// })
// function SingleEmployeeAttendance() {
//   const classes = useStyles()
//   const params = useParams()
//   const { employeeAttendance } = useContext(ConfigurationContext)
//   const { getEmployeeAttendance, deleteEmployeeAttendance, deleteEmployeeManyAttendance, loading } = useAttendance()
//   const filterSingleAttendance = employeeAttendance
//   const startDate = new Date()
//   startDate.setDate(1)
//   startDate.setHours(0, 0, 0)
//   const [from, setFrom] = React.useState(startDate)
//   const [to, setTo] = React.useState(new Date())
//   //console.log('FILTERED ATTENDANCE ', filterSingleAttendance)
//   const [page, setPage] = React.useState(1)
//   const [lastModifiedOpen, setLastModifiedOpen] = React.useState(false)
//   const [imageDialog, setImageDialog] = useState(false)
//   const [image, setImage] = useState(false)
//   const handleLastModifiedOpen = () => {
//     setLastModifiedOpen(false)
//   }
//   const [selected, setSelected] = React.useState([])
//   const [deleteDialog, setDeleteDialog] = React.useState(false)
//   const noOfPages = Math.ceil(filterSingleAttendance && filterSingleAttendance.length / itemsPerPage)

//   const handleChange = (event, value) => {
//     setPage(value)
//   }
//   let multipleId = []
//   selected.length && selected.map((item) => multipleId.push(item._id))
//   const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)

// useEffect(() => {
//   getEmployeeAttendance({ employeeId: params.employeeId, from: from, to: to })
// }, [params.employeeId, from, to])
//   return (
//     <Layout
//       heading={`Attendance`}
//       // selectedFrom={from}
//       // setSelectedFrom={setFrom}
//       // selectedTo={to}
//       // setSelectedTo={setTo}
//       setDeleteDialog={setDeleteDialog}
//       heading2={` ${filterSingleAttendance ? filterSingleAttendance[0].EmployeeId.firstName : 'No Record Found'}`}
//
//       // deleteData={}
//       editUrl={`/edit-attendance/${selected.length && selected[0]._id}`}
//       setMultipleDeleteDialog={setMultipleDeleteDialog}
//       none
//       selectedData={selected}
//     >
//       <div>
//         <CustomTable>
//           <CustomTableHeading
//             heading={[
//               <Checkbox
//                 indeterminate={selected.length > 0 && selected.length < filterSingleAttendance.length}
//                 checked={filterSingleAttendance.length > 0 && selected.length === filterSingleAttendance.length}
//                 onClick={(event) => handleSelectAllClick(event, filterSingleAttendance, setSelected)}
//               />,
//               'name',
//               'position',
//               'in time',
//               'out time',
//               'productive hrs',
//               'location',
//               'check in',
//               'check out',
//               'last modified by',
//               'status',
//             ]}
//           />
//           <TableBody>
//             {!loading &&
//               Boolean(filterSingleAttendance.length) &&
//               filterSingleAttendance.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
//                 const isItemSelected = isSelected(item, selected)
//                 return (
//                   <CustomTableRow>
//                     <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
//                       <Checkbox checked={isItemSelected} />
//                     </TableCell>
//                     <TableCell>{item.EmployeeId && item.EmployeeId.firstName}</TableCell>
//                     <TableCell>{item.EmployeeId && item.EmployeeId.position && item.EmployeeId.position.positionName}</TableCell>
//                     <TableCell style={{ textAlign: 'center' }}>{formatDate(item.attendanceTime)}</TableCell>
//                     <TableCell>{item.checkOutTime ? formatDate(item.checkOutTime) : '---'}</TableCell>
//                     <TableCell>{diffDateInHrs(item.attendanceTime, item.checkOutTime ? item.checkOutTime : new Date())}</TableCell>
//                     <TableCell>
//                       <LocationOnOutlinedIcon style={{ color: '#32499F' }} /> {item.state}
//                     </TableCell>
//                     <TableCell
//                       onClick={() => {
//                         setImageDialog(true)
//                         setImage(item.picture)
//                       }}
//                     >
//                       <Avatar src={item.picture} style={{ cursor: 'pointer' }} />
//                     </TableCell>
//                     <TableCell
//                       onClick={() => {
//                         setImageDialog(true)
//                         setImage(item.checkOutImage ? item.checkOutImage : null)
//                       }}
//                     >
//                       <Avatar src={item.checkOutImage ? item.checkOutImage : null} style={{ margin: '0px auto', cursor: 'pointer' }} />
//                     </TableCell>

//                     <TableCell>
//                       {item.updatedBy ? (
//                         <Box textAlign="center">
//                           <Box display="flex" justifyContent="space-evenly" marginBottom="5px">
//                             <CustomImage image={Icon} onClick={() => setLastModifiedOpen(true)} className={classes.cursor} />
//                             {item.updatedBy && item.updatedBy.firstName}
//                           </Box>

//                           {`${new Date(item.updatedAt).getDate()}/${new Date(item.updatedAt).getMonth() + 1}/${new Date(item.updatedAt).getFullYear()}`}
//                         </Box>
//                       ) : (
//                         '---'
//                       )}
//                     </TableCell>
//                     <TableCell>
//                       {item.lateFlag ? (
//                         <Box display="flex" justifyContent="space-evenly">
//                           <CustomImage image={Time} />
//                           <CustomLabel label="LATE" />
//                         </Box>
//                       ) : (
//                         <Status label={item.Present} />
//                       )}
//                     </TableCell>
//                   </CustomTableRow>
//                 )
//               })}
//           </TableBody>
//         </CustomTable>
//         <ImageDialog open={image && imageDialog} handleClose={() => setImageDialog(false)} image={image} />
//         {!loading && !filterSingleAttendance.length && <NoDataFound />}
//         {loading && <Loader />}

//         <ConfirmDialog
//           open={deleteDialog}
//           handleClose={() => setDeleteDialog(false)}
//           name={selected.length === 1 && selected[0].EmployeeId && selected[0].EmployeeId.firstName}
//           handleSubmit={() => deleteEmployeeAttendance({ attendanceId: selected[0]._id }, setSelected)}
//         />
//         <ConfirmDialog
//           open={multipleDeleteDialog}
//           handleClose={() => setMultipleDeleteDialog(false)}
//           name={selected.length === 1 && selected[0].name}
//           handleSubmit={() => deleteEmployeeManyAttendance({ attendanceId: multipleId }, setSelected)}
//         />

//         <div style={{ display: 'flex', justifyContent: 'center' }}>{filterSingleAttendance && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}</div>
//       </div>
//     </Layout>
//   )
// }

// export default SingleEmployeeAttendance

import React, { useContext, useEffect, useState } from 'react'

import { useHistory, useParams } from 'react-router-dom'
import CustomTableLayout from '../components/CustomComponents/CustomTableLayout'
import { ConfigurationContext } from '../context api/Configuration/ConfigurationContext'

import { useAttendance } from '../hooks/Features/useAttendance'
import { diffDateInHrs, formatDate, formatTime, ROUTES } from '../shared/constants'

export default function SingleEmployeeAttendance() {
  const { getEmployeeAttendance, deleteEmployeeAttendance, deleteEmployeeManyAttendance, loading } = useAttendance()

  const history = useHistory()
  const { employeeAttendance } = useContext(ConfigurationContext)

  const filterAttendance = employeeAttendance

  const params = useParams()
  useEffect(() => {
    getEmployeeAttendance({ employeeId: params.employeeId })
  }, [params.employeeId])

  let tableBody = []
  //
  if (!loading && filterAttendance.length > 0) {
    tableBody = filterAttendance.map((item) => {
      return [
        { value: formatDate(item.createdDate) },
        { value: item.EmployeeId && item.EmployeeId.position && item.EmployeeId.position.positionName },
        { value: item.Present !== 'PRESENT' ? 'N/A' : formatTime(item.attendanceTime) },
        { value: item.Present !== 'PRESENT' ? 'N/A' : item.checkOutTime ? formatTime(item.checkOutTime) : '---' },
        {
          value: item.Present !== 'PRESENT' ? 'N/A' : diffDateInHrs(item.attendanceTime, item.checkOutTime ? item.checkOutTime : new Date()),
        },
        { type: 'LOCATION', location: item.city ? item.city : 'N/A', currentLocation: item.currentLocation },
        { type: 'IMAGE', image: item.picture },
        { type: 'IMAGE', image: item.checkOutImage },
        { status: item.Present, type: 'STATUS_ENUM', lateFlag: item.lateFlag },
      ]
    })
  }

  const layoutProps = {
    heading: 'Attendance',
    heading2: filterAttendance ? filterAttendance[0].EmployeeId.firstName : 'No Record Found',
    url1: ROUTES.ALL_ATTENDANCE,
  }

  return (
    <CustomTableLayout
      tableHeadings={[
        'DATE',
        'position',
        'in time',
        'out time',
        'productive hrs',
        'City',
        'check in',
        'check out',
        // 'last modified by',
        'status',
      ]}
      loading={loading}
      tableBody={tableBody}
      layoutProps={layoutProps}
      paginateFront
      noSync
    />
  )
}
